export default {
  sections: {
    alcohol_percentage: 'Contenido de alcohol: {{value}}%',
    price_per_unit: 'Precio por {{unit}}: {{value}}',
    gtin: 'GTIN',
    ingredients: 'Ingredientes',
    allergens: 'Alérgenos',
    additives: 'Aditivos',
    nutrition_breakdown: {
      title: 'Información nutricional',
      description: '100 {{unit}} contiene:',
      items: {
        energy: 'Energía',
        fat: 'Grasas',
        saturates: 'de las cuales ácidos grasos saturados',
        carbohydrates: 'Hidratos de carbono',
        sugars: 'de los cuales azúcares',
        protein: 'Proteínas',
        salt: 'Sal',
      },
    },
  },
  units: {
    l: 'litro',
    kg: 'kilo',
    default: 'unidad',
  },
};
